var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CLOSE_DISABLED",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CLOSE_DISABLED .cls-1 {\n        fill: #9ea1a2;\n      }\n\n      #CLOSE_DISABLED .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_CLOSE_DISABLED",
    transform: "translate(-311 -316)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(311 316)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    "data-name": "Linie 17",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 333.661) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 321.661) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDisabled);
export default __webpack_public_path__ + "static/media/close-disabled.26fb8bd03563f6f38e9a7edc96ecbc0d.svg";
export { ForwardRef as ReactComponent };